import { Flex } from "antd";
import { useParams } from "react-router-dom";
import { UserRole } from "tm-shared/types";

import Header from "@/components/Header";
import { MainContainer } from "@/components/Layout/Styled";
import Meta from "@/components/Meta";
import { useAppSelector } from "@/hooks/redux";
import DashboardTabs from "@/pages/Dashboard/DashboardTabs";

import { SelfPlan } from "./DashboardTabs/SelfPlan";
import { Salary } from "./Salary";

const Dashboard = () => {
    const { role, id } = useAppSelector((state) => state.user);
    const { userId } = useParams();
    const currentUserId = role === UserRole.Ta ? id : userId;

    return (
        <>
            <Meta title="Дашборд" />
            <Header withMidnightCountdown />
            <MainContainer>
                <Flex
                    vertical
                    gap={12}
                    flex={1}
                    style={{ minHeight: 0, width: "100%" }}
                >
                    {role === UserRole.Ta && (
                        <>
                            <Salary targetDB="db-ta" />
                            <DashboardTabs userId={currentUserId} />
                        </>
                    )}

                    {role === UserRole.Sv && (
                        <>
                            <Salary targetDB="db-sv" />
                            <SelfPlan targetDB="db-sv" />
                        </>
                    )}
                </Flex>
            </MainContainer>
        </>
    );
};

export default Dashboard;
